import { createPortal } from 'react-dom';
import type { ReactNode } from 'react';

/**
 * Renders overlays at the end of <body> so no ancestor (page transitions,
 * filters, transforms) can trap a `position: fixed` layer under the nav.
 */
export function Portal({ children }: { children: ReactNode }) {
  if (typeof document === 'undefined') return <>{children}</>;
  return createPortal(children, document.body);
}
